import { parsePermissionKeys } from '@evimo/types/enums/permission-key';
import type { RoleDetailResponseDto } from '@evimo/types/api/authorization/role/role-detail.response.dto';
import type { RoleWithPermissionsResponseDto } from '@evimo/types/api/authorization/role/role-with-permissions.response.dto';
import type { RoleDetailResponseDto as ClientRoleDetailResponseDto } from '@evimo/client/models/RoleDetailResponseDto';
import type { RoleWithPermissionsResponseDto as ClientRoleWithPermissionsResponseDto } from '@evimo/client/models/RoleWithPermissionsResponseDto';

export function mapRoleDetailResponse(
  role: ClientRoleDetailResponseDto,
): RoleDetailResponseDto {
  return {
    ...role,
    permissionKeys: parsePermissionKeys(role.permissionKeys),
  };
}

export function mapRoleWithPermissionsResponse(
  role: ClientRoleWithPermissionsResponseDto,
): RoleWithPermissionsResponseDto {
  return {
    ...role,
    permissionKeys: parsePermissionKeys(role.permissionKeys),
  };
}
